import { HttpEvent, HttpHandler, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { of, BehaviorSubject, Observable } from 'rxjs';
import { HttpResponse, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { switchMap, filter, take, catchError, map } from 'rxjs/operators';
import { AbpHttpInterceptor } from 'abp-ng2-module';

@Injectable()
export class SironaHttpInterceptor extends AbpHttpInterceptor {

    static sendWithCredentials = false;
    static urlsToSkipRequestHeaderNormalization: string[] = [];

    protected normalizeRequestHeaders(request: HttpRequest<any>): HttpRequest<any> {
        if (SironaHttpInterceptor.sendWithCredentials) {
            request = request.clone({ withCredentials: true });
        }

        if (SironaHttpInterceptor.urlsToSkipRequestHeaderNormalization.some(x => x === request.url)) {
            return request;
        }

        return super.normalizeRequestHeaders(request);
    };

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        let modifiedRequest = this.normalizeRequestHeaders(request);
        return next.handle(modifiedRequest)
            .pipe(
                catchError(error => {
                    if (error instanceof HttpErrorResponse && (error.status === 401 || (error.status === 403))) {
                        return this.tryAuthWithRefreshTokenSirona(request, next, error);
                    } else {
                        return this.handleErrorResponse(error);
                    }
                }),
                switchMap((event: HttpEvent<any>) => this.handleSuccessResponse(event))
            );
    }

    private isRefreshingSirona = false;
    private refreshTokenSubjectSirona: BehaviorSubject<any> = new BehaviorSubject<any>(null);

    private tryAuthWithRefreshTokenSirona(request, next, error) {
        if (!this.isRefreshingSirona) {
            this.isRefreshingSirona = true;
            this.refreshTokenSubjectSirona.next(null);
            return this.tryGetRefreshTokenService().pipe(switchMap((authResult) => {
                this.isRefreshingSirona = false;
                if (authResult) {
                    this.refreshTokenSubjectSirona.next(authResult);
                    let modifiedRequest = this.normalizeRequestHeaders(request);
                    return next.handle(modifiedRequest);
                }
                else {
                    return this.handleErrorResponse(error);
                }
            }));
        } else {
            return this.refreshTokenSubjectSirona.pipe(filter(authResult => authResult != null), take(1), switchMap(authResult => {
                let modifiedRequest = this.normalizeRequestHeaders(request);
                return next.handle(modifiedRequest);
            }));
        }
    }
};
